<app-loading-state *ngIf="spinner && !ready" [message]="spinnerMessage"></app-loading-state>
<convfact-financiacion-propia-form *ngIf="ready" [financiacionPropia]="financiacionPropia" (onSave)="saveData($event)">
</convfact-financiacion-propia-form>
<div class="fin-saving-overlay" *ngIf="spinner && ready">
  <app-loading-state [message]="spinnerMessage"></app-loading-state>
</div>
